import { Image } from '@ds';
import { trialImageByOrgan } from '@/constants/case/case.constants';
import { OrganType } from '@/api/apis/case';

export type TrialProgramImageProps = {
  organ?: OrganType;
  width?: number;
  height?: number;
};

export const TrialProgramImage = ({ organ, width = 103, height = 32 }: TrialProgramImageProps) => {
  if (!organ) return null;

  return (
    <Image
      className="rounded-none"
      src={trialImageByOrgan[organ]}
      alt={`${organ} trial logo`}
      width={width}
      height={height}
    />
  );
};
